import { findRivalry } from "@averagejoesff/shared";
import type { MatchupReport } from "@averagejoesff/shared";
import type { ManagerLookup } from "./managers";
import { managerName } from "./managers";
import { matchupAnchorId, seriesSummary } from "./series";

interface MatchupSlateProps {
  report: MatchupReport;
  managers: ManagerLookup;
}

/** The week's games at a glance, each linking down to its card. */
export function MatchupSlate({ report, managers }: MatchupSlateProps) {
  if (report.matchups.length === 0) return null;
  return (
    <nav aria-labelledby="matchup-slate-heading">
      <h3 id="matchup-slate-heading" className="feature__subhead">
        This week's games
      </h3>
      <ul className="matchup-slate">
        {report.matchups.map(({ managerIds }) => {
          const [leftId, rightId] = managerIds;
          const rivalry = findRivalry(report, leftId, rightId);
          return (
            <li key={managerIds.join("-")}>
              {/* A plain in-page anchor: the router only tracks the pathname, so the hash is harmless. */}
              <a className="matchup-slate__link" href={`#${matchupAnchorId(managerIds)}`}>
                <span className="matchup-slate__pair">
                  <span className="matchup-slate__name matchup-slate__name--left">{managerName(managers, leftId)}</span>
                  <span className="matchup-slate__vs">vs</span>
                  <span className="matchup-slate__name matchup-slate__name--right">{managerName(managers, rightId)}</span>
                </span>
                <span className="matchup-slate__series">
                  {rivalry ? seriesSummary(rivalry, managers) : "First meeting"}
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
